import React from 'react';
import "./home.css";
import Navbar from '../components/navbar/navbar';
import Hero from '../components/sections/hero';
import Numberbtn from '../components/numberbtns/numberbtn';
import greyimg from "../assets/greyimg.png";
import homeabs from "../assets/homeabs.png";
import urban from "../assets/urb.svg"
import Title from '../components/title/title';
import Prop from '../components/property/prop';
import house1 from "../assets/house1.png"
import house2 from "../assets/house02.png"
import house3 from "../assets/house03.png"
import icon1 from "../assets/icon01.svg"
import icon2 from "../assets/icon02.svg"
import icon3 from "../assets/icon03.svg"
import service1 from "../assets/service01.svg"
import service2 from "../assets/service02.svg"
import service3 from "../assets/service03.svg"
import Service from '../components/services/service';
import userimg1 from "../assets/userimg01.png"
import userimg2 from "../assets/userimg02.png"
import userimg3 from "../assets/userimg03.png"
import Review from '../components/review/review';
import Blackbtn from '../components/blackbtn/blackbtn';
import Footer from '../components/sections/footer';
import { Link } from 'react-router-dom';

const Home = () => {
    return ( 
        <>
            <Navbar />
            <Hero />

            <section className="sec1">
                <div className="secwrap">
                <div className="sec1txt">
                    <h1>Find Your Dream Property</h1>
                    <p>Discover exceptional homes that match your lifestyle. From modern apartments to luxury estates, we have the perfect property waiting for you.</p>
                </div>

                <div className="numbers">
                    <Numberbtn stylebox='numberbtngrey' number='10M+' text='Happy Customers' imgclass='img1' imgsrc={greyimg} textstyle='texth' textstylep='textp'/>
                    <Numberbtn stylebox='numberbtnblack' number='500K+' text='Properties Sold' imgclass='abs' imgsrc={homeabs} textstyle='white' textstylep='whitep'/>
                    <Numberbtn stylebox='numberbtnblack' number='8+' text='Agents Worldwide' imgclass='urb' imgsrc={urban} textstyle='white' textstylep='whitep'/>
                </div>

                </div>
            </section>

            <section className="section2">
                <Title stylebox="title" classname='titleblack' text='Featured Properties' pclass='pblack' para='Handpicked collection of our finest properties available for sale' />

                <div className="propwrap">
                    <Link to="/property" className='propblock'>
                    <Prop img={house1} propname='Modern Apartment' desc='A stylish apartment in the heart of the city with stunning views.' offer1={icon1} offer1num='3 Beds' offer2={icon2} offer2num='2 Baths' offer3={icon3} offer3num='1500 sqft' />
                    </Link>
                    <Link to="/property" className='propblock'>
                    <Prop img={house2} propname='Luxury Villa' desc='A spacious villa with panoramic views and premium amenities.' offer1={icon1} offer1num='5 Beds' offer2={icon2} offer2num='3 Baths' offer3={icon3} offer3num='3000 sqft' />
                    </Link>
                    <Link to="/property" className='propblock'>
                    <Prop img={house3} propname='Cozy Cottage' desc='A charming cottage nestled in a peaceful countryside setting.' offer1={icon1} offer1num='2 Beds' offer2={icon2} offer2num='1 Bath' offer3={icon3} offer3num='800 sqft' />
                    </Link>
                </div>

                <button className="view">View All Properties</button>
            </section>

            <section className="section3">
                <Title stylebox="title" classname='titleblack' text='Our Service' pclass='pblack' para='We provide exceptional service and expertise to help you find your perfect property' />
                <div className="services">
                    <Service imgsrc={service1} text='Personalized Property Search' para='Tailored property recommendations based on your preferences and needs.' />
                    <Service imgsrc={service2} text='Expert Guidance' para='Professional advice and support throughout your property journey.' />
                    <Service imgsrc={service3} text='Comprehensive Listings' para='Access to a wide range of properties to suit every budget and lifestyle.' />
                </div>
            </section>
            
            <section className="section4">
                <Title stylebox="title" classname='titlewhite' text='What Our Clients Say' pclass='pwhite' para='Real stories from real people who found their dream homes with us' />
                <div className="reviewstab">
                    <div className="reviewscont">

                    <Review text="The driving experience has exceeded all my expectations. The car feels incredibly stable on the road, even at high speeds, and the acceleration is smooth without any delay. What surprised me most is the impressive fuel efficiency." userimg={userimg1} name="Omar Kareem" city="Cairo"    />
                    <Review text="The driving experience has exceeded all my expectations. The car feels incredibly stable on the road, even at high speeds, and the acceleration is smooth without any delay. What surprised me most is the impressive fuel efficiency." userimg={userimg2} name="Omar Kareem" city="Cairo"    />
                    <Review text="The driving experience has exceeded all my expectations. The car feels incredibly stable on the road, even at high speeds, and the acceleration is smooth without any delay. What surprised me most is the impressive fuel efficiency." userimg={userimg3} name="Omar Kareem" city="Cairo"    />
                
                    
                    </div>
                </div>

              
            </section>

            <section className="section5">
                <Title stylebox="title" classname="titleblack" pclass="pblack" text="Ready to Find Your Dream Home?" para="Schedule a personalized viewing with one of our expert agents today"/>
                <div className="btnscta">
                <Blackbtn css1="whitebtn" name="Browse Properties"/>
                <Blackbtn css1="blackbtn" name="Contact Agent"/>
                </div>
            </section>

            <Footer />
            
        </>
     );
}
 
export default Home;